import { animate, motion, useMotionValue, useTransform } from 'motion/react';
import { useEffect, useCallback } from 'react';

interface AnimatedOdometerProps {
  value: number;
  className?: string;
  duration?: number;
}

export default function AnimatedOdometer({ 
  value, 
  className = '', 
  duration = 1.5 
}: AnimatedOdometerProps) {
  const count = useMotionValue(0);
  const rounded = useTransform(count, useCallback((val: number) => Math.round(val), []));

  useEffect(() => {
    const animation = animate(count, value, {
      duration,
      ease: [0.22, 1, 0.36, 1],
    });

    return animation.stop;
  }, [value, count, duration]);

  return (
    <motion.span
      className={className}
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      <motion.span>{rounded}</motion.span>%
    </motion.span>
  );
}